module.exports = __webpack_public_path__ + "static/img/10013 (4).08d50c9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (4).webp
// module id = InnI
// module chunks = 14